export default __webpack_public_path__ + "static/media/Etu.c4a992da.png";